module.exports = __webpack_public_path__ + "928b6218b646722e2e8d0076354e0e2b.mp4";